import React from 'react';
import './subscription.scss';
import InviteAndEarn from 'components/web/InviteAndEarn/InviteAndEarn';
import Input from 'components/mweb/Input/Input';
import Button from 'components/common/Button/Button';
import { Link } from 'react-router-dom';
import { subscribeNewUser } from 'hb-redux-store/feature/checkout/checkout.action';
import { connect } from 'react-redux';
import orderConfirmationImage from '../../../assets/order-confirmation-paperbag.png';
import OrderDetails from '../account/OrderDetails';
import { isValidEmail } from 'hb-redux-store/util/miscellaneousServices';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { getSubscriptionConfirmation } from 'hb-redux-store/feature/subscription/subscription.action';

class SubscriptionConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDetails: '',
    };
    this.orderNo = props.match.params.subscriptionNo;
    this.state = { email: '', emailErrorMsg: '' };
  }
  componentDidMount() {
    this.props.getSubscriptionConfirmation({ subscriptionNo: this.orderNo });
  }

  subscribeToOffers = () => {
    if (!this.state.email.length || !isValidEmail(this.state.email)) {
      this.setState({ emailErrorMsg: 'Please enter valid email Id. ' });
      return;
    }
    const data = {
      accountEmail: this.state.email,
      subscriptionType: 'dealsAndOffers',
    };
    const cb = () =>
      this.props.setAppNotification(
        'Subscribed! You will be receiving latest updates from Halalbox. Stay tuned!'
      );
    this.props.subscribeNewUser(data, cb);
    this.setState({ emailErrorMsg: '' });
  };

  render() {
    const { subscriptionConfirmationDetails } = this.props,
      { orderDetails } = this.state;
    let {
      orderType,
      paymentLink,
      paid,
      orderPayableAmount,
      ccalogin,
      baseUrl,
    } = subscriptionConfirmationDetails || {};
    console.log('Is CCA: ', ccalogin, baseUrl);
    if (ccalogin && baseUrl) {
      window.location.href = `${baseUrl}/order/edit/${this.orderNo}`;
    }
    return (
      <React.Fragment>
        {!orderDetails ? (
          <div className="desktop-order-confirm">
            <div className="desktop-order-confirm--content">
              <div className="desktop-order-confirm--content--msg">
                <div className="desktop-order-confirm--content--msg--container">
                  <div className="main-text">
                    Your subscription is successful!
                  </div>
                  <div className="payment-text">
                    {orderType === 'POL' && (
                      <span>
                        Payment of &#8377;
                        {orderPayableAmount} is successful for your subscription
                        #{this.orderNo}
                      </span>
                    )}
                    {orderType === 'COD' && (
                      <span>
                        Please keep &#8377;
                        {orderPayableAmount} ready for your COD subscription #
                        {this.orderNo}
                      </span>
                    )}
                    {orderType === 'POD' && !paid && paymentLink && (
                      <span>
                        Payment of &#8377;{orderPayableAmount} for your
                        subscription #{this.orderNo} is pending.
                        <a
                          href={paymentLink}
                          className="std-margin-tb button button-primary full-width large"
                        >
                          Pay &#8377;{orderPayableAmount}
                        </a>
                      </span>
                    )}
                    {((orderType === 'POD' && paid) || orderType === 'HBW') && (
                      <span>
                        Your subscription no #{this.orderNo} is successful.
                      </span>
                    )}
                  </div>
                  {/*<div className="track-order">*/}
                  {/*  <Link*/}
                  {/*    to={`/my/order/${this.orderNo}`}*/}
                  {/*    className="button button-ghost full-width large"*/}
                  {/*    onClick={() =>*/}
                  {/*      this.setState({ orderDetails: this.orderNo })*/}
                  {/*    }*/}
                  {/*  >*/}
                  {/*    TRACK ORDER*/}
                  {/*  </Link>*/}
                  {/*</div>*/}
                </div>
                <div>
                  <img className="image" src={orderConfirmationImage} />
                </div>
              </div>
              <div className="desktop-order-confirm--content--illustration">
                <InviteAndEarn
                  iGet={this.props.launchInfo?.referrerRewardAmount}
                  myFriendsGet={this.props.launchInfo?.refereeRewardAmount}
                  orderConfirmation={true}
                />

                <div className="desktop-order-confirm--subscribe">
                  <div className="desktop-order-confirm--subscribe--title">
                    Subscribe to know about our deals & Offers
                  </div>
                  <div className="desktop-order-confirm--subscribe--email-input">
                    <Input
                      type="text"
                      name="email"
                      className="full-width"
                      hasError={!!this.state.emailErrorMsg?.length}
                      errorMsg={this.state.emailErrorMsg}
                      suffix={
                        <Button
                          className="button action-link subscribe-cta desktop-address-card--edit-action"
                          onClick={this.subscribeToOffers}
                        >
                          SUBMIT
                        </Button>
                      }
                      onChange={({ email }) => this.setState({ email })}
                      placeholder="Enter your email id here"
                      value={this.state.email}
                    />
                  </div>
                </div>
                <div>
                  <Link
                    to={'/'}
                    className="button button-primary full-width large"
                  >
                    Explore other items
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <OrderDetails orderNo={orderDetails} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ subscriptionReducer, initialReducer }) => ({
  subscriptionConfirmationDetails:
    subscriptionReducer.subscriptionConfirmationDetails,
  launchInfo: initialReducer.launchInfo,
});

const mapDispatchToProps = {
  subscribeNewUser,
  setAppNotification,
  getSubscriptionConfirmation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionConfirmation);
